import Component from './MonetizationPromoBanner';
import Container from './MonetizationPromoBanner.container';

export default Container(Component);
